<script>
import createChartComponent from "./createChartComponent";

export default createChartComponent("bar-chart", "bar");
</script>
